import React from 'react';
import pikkocoin from '../../styles/img/Pikkocoin.svg';
import CustomLoader, {
  LoaderColor,
  LoaderSize,
} from '../../components/loader/CustomLoader';
import { useSelector } from 'react-redux';
import { isAppPWA } from '../../utils/helper-functions';

const ConversionTile = ({
  name,
  cost,
  icon,
  disabled,
  onValidate,
  isLoading,
}) => {
  const { store } = useSelector((state) => state.store);
  const handleClick = () => {
    if (disabled || isLoading) {
      return;
    }
    onValidate();
  };
  return (
    <>
      {store?.permissions?.promo && (
        <div
          className={`conversion-tile ${disabled ? 'disabled' : ''}`}
          onClick={handleClick}
        >
          <div className="conversion-name-container">
            <img className="discount-type-img" src={icon} alt="Pikkocoin" />
            <div className="conversion-name">{name}</div>
          </div>
          {isLoading ? (
            <div>
              <CustomLoader
                loaderSize={LoaderSize.SMALL}
                loaderColor={LoaderColor.BLACK}
              />
            </div>
          ) : (
            <div className="conversion-cost-container">
              <img className="picoin-img" src={pikkocoin} alt="Pikkocoin" />
              <div className="conversion-cost">{cost}</div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ConversionTile;
